/* ============================================================
   PRODUCT DATA — single source of truth for the quiz result cards
   Keys are referenced from the recommendation tree
   ============================================================ */
const PRODUCTS = {
  'swallow-ul': {
    name: 'Swallow', nameSecondary: 'UL 20° & 30°', label: 'Award Winner',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-swallow-ul-ultralight-down-20-30-degree-sleeping-bag-flame-orange-with-cerulean-accent-open.jpg?v=1760383114',
    tagline: 'Our flagship ultralight mummy. Most reviewed, most awarded.',
    temp: '20º to 30ºF / -6º to -1ºC', weight: '1 lb 5 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'The Swallow UL 20 is a champ in the world of ultralight sleeping bags. An impressive combination of exceptional warmth, minimal weight, and high-quality materials.',
    quoteSrc: 'CleverHiker — Top Pick',
    price: 'From $599', url: '/products/swallow-ul-ultralight-20-30-degree-down-sleeping-bag-c0'
  },
  'hummingbird-ul': {
    name: 'Hummingbird', nameSecondary: 'UL 20° & 30°', label: 'Lightest',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-hummingbird-ul-ultralight-down-20-30-degree-sleeping-bag-graphite-gray-open.jpg?v=1759449071',
    tagline: 'Our narrowest, lightest mummy. Built for the gram-counter.',
    temp: '20º to 30ºF / -6º to -1ºC', weight: '1 lb 4 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'The Feathered Friends Hummingbird UL 30 is our top choice when saving weight is paramount.',
    quoteSrc: 'Outdoor Gear Lab',
    price: 'From $579', url: '/products/hummingbird-ul-ultralight-20-30-degree-down-sleeping-bag'
  },
  'egret-ul': {
    name: 'Egret', nameSecondary: 'UL 20° & 30°', label: "Women's",
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-egret-ul-ultralight-womens-down-20-30-degree-sleeping-bag-magenta-purple-open.jpg?v=1759354898',
    tagline: "Our women's-specific flagship. Warmer through the core, narrower shoulder.",
    temp: '20º to 30ºF / -6º to -1ºC', weight: '1 lb 6 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'One of the most well-constructed and highest quality bags in this review.',
    quoteSrc: 'Outdoor Gear Lab',
    price: 'From $569', url: '/products/egret-ul-ultralight-20-30-degree-womens-down-sleeping-bag'
  },
  'petrel-ul-10': {
    name: 'Petrel', nameSecondary: 'UL 10°', label: "Women's · Warmest",
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-petrel-ul-ultralight-womens-down-10-degree-sleeping-bag-cerulean-blue-unzipped.jpg?v=1761699051',
    tagline: "Our warmest three-season women's bag. For cold sleepers and shoulder-season alpine.",
    temp: '10°F / -12°C', weight: '1 lb 14 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: "I have never slept better in the backcountry. I'll be a Feathered Friends fan for life.",
    quoteSrc: 'Bekah, verified customer',
    price: 'From $639', url: '/products/petrel-ul-10-degree-ultralight-womens-down-sleeping-bag'
  },
  'flicker-ul': {
    name: 'Flicker', nameSecondary: 'UL Quilt', label: 'Versatile',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-flicker-ul-ultralight-down-quilt-sleeping-bag-20-30-40-degree-flame-orange.jpg?v=1759362199',
    tagline: 'Hoodless quilt. Adaptable across temperatures. Thru-hiker beloved.',
    temp: '20°F to 40°F', weight: '1 lb 4 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'Due to its exceptional adaptability, the Flicker is an excellent choice for long-distance routes like the Pacific Crest Trail.',
    quoteSrc: 'Outdoor Gear Lab',
    price: 'From $499', url: '/products/flicker-ul-ultralight-down-quilt-sleeping-bag'
  },
  'flicker-wide-ul': {
    name: 'Flicker Wide', nameSecondary: 'UL Quilt', label: 'Roomy',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-flicker-ul-wide-ultralight-down-quilt-sleeping-bag-20-30-40-degree-cerulean-blue_ee33b104-9b31-420f-8db0-f96a0672f769.jpg?v=1761805789',
    tagline: 'Wider Flicker for restless sleepers and side sleepers.',
    temp: '20°F to 40°F', weight: '1 lb 5 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: "For people who want both a sleeping bag and a quilt option that’s both high quality and lightweight.",
    quoteSrc: 'GearJunkie',
    price: 'From $529', url: '/products/flicker-ul-wide-ultralight-down-quilt-sleeping-bag'
  },
  'vireo-ul': {
    name: 'Vireo', nameSecondary: 'UL Minimalist', label: 'Minimalist',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-vireo-ul-ultralight-minimalist-down-sleeping-bag-flame-orange.jpg?v=1761003725',
    tagline: 'Pair with your puffy. The lightest sleep system we make.',
    temp: '45°F / 25°F', weight: '15 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'We find the Vireo UL oh so comfy without any zippers or other features next to our skin and the perfect companion when you feel the need for speed.',
    quoteSrc: 'Outdoor Gear Lab',
    price: 'From $429', url: '/products/vireo-ul-ultralight-minimalist-down-sleeping-bag'
  },
  'tanager-cfl': {
    name: 'Tanager', nameSecondary: 'CFL 20°', label: 'Fast & Light',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/tanager-ultralight-minimalist-down-sleeping-bag.jpg?v=1777141567',
    tagline: 'Stripped-down minimalist bag for fast-and-light alpine starts.',
    temp: '20°F / -6°C', weight: '1 lb 1 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'A full two-thirds of this bag’s 20-ounce weight is devoted to down feathers, giving it the best warmth to weight ratio on this list.',
    quoteSrc: 'The Trek',
    price: 'From $469', url: '/products/tanager-cfl-ultralight-down-sleeping-bag'
  },
  'spoonbill-ul': {
    name: 'Spoonbill', nameSecondary: 'UL 2-Person', label: '2-Person',
    image: 'https://cdn.shopify.com/s/files/1/0140/2791/5318/files/feathered-friends-spoonbill-ul-ultralight-2-person-down-sleeping-bag-flame-orange.jpg?v=1774394039',
    tagline: 'A genuine two-person ultralight bag. For couples and shared shelters.',
    temp: '20°F / -6°C', weight: '2 lb 11 oz', fill: '950+ Fill Power Goose Down', fabric: 'Pertex® Quantum Pro',
    quote: 'A genuine two-person bag with the warmth and weight to back up the concept.',
    quoteSrc: 'CleverHiker',
    price: 'From $1029', url: '/products/spoonbill-ul-ultralight-2-person-down-sleeping-bag'
  }
};

/* ============================================================
   STATE & STEP NAVIGATION
   ============================================================ */
const state = { currentStep: 0, answers: {}, started: false };

const steps = document.querySelectorAll('.quiz-step');
const result = document.getElementById('result');
const progressFill = document.getElementById('progressFill');
const progressLabel = document.getElementById('progressLabel');
const progressEl = document.getElementById('progress');

function showStep(idx) {
  steps.forEach(s => s.classList.remove('active'));
  result.classList.remove('active');

  if (idx < steps.length) {
    steps[idx].classList.add('active');
    progressFill.style.width = (idx / 3 * 100) + '%';
    progressLabel.textContent = `Question ${idx + 1} of 3`;
    progressEl.style.display = 'flex';
  } else {
    progressEl.style.display = 'none';
    result.classList.add('active');
    renderResult();
  }
  state.currentStep = idx;
}

document.querySelectorAll('.option').forEach(opt => {
  opt.addEventListener('click', () => {
    const q = opt.dataset.q, a = opt.dataset.a;
    state.answers[q] = a;

    // Pixel events — fire if available
    if (!state.started) {
      state.started = true;
      trackEvent('QuizStart', { quiz_name: 'find_your_bag' });
    }
    trackEvent('QuizAnswer', { quiz_name: 'find_your_bag', question: q, answer: a, step: state.currentStep + 1 });

    document.getElementById('quiz').scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => showStep(state.currentStep + 1), 320);
  });
});

document.querySelectorAll('[data-back]').forEach(btn => {
  btn.addEventListener('click', () => {
    if (state.currentStep > 0) showStep(state.currentStep - 1);
  });
});

/* ============================================================
   RECOMMENDATION TREE
   ============================================================ */
function recommend() {
  const { temp, fit, who } = state.answers;

  // Edge case: winter
  if (temp === 'below10') {
    return { type: 'winter_redirect' };
  }

  // Edge case: pair
  if (who === 'pair') {
    const ids = temp === '10to20' ? ['spoonbill-ul', 'petrel-ul-10', 'flicker-ul']
              : temp === '20to30' ? ['spoonbill-ul', 'flicker-ul', 'egret-ul']
              : ['spoonbill-ul', 'flicker-ul', 'flicker-wide-ul'];
    return {
      type: 'recs',
      heading: 'A pair, designed to <em>share warmth.</em>',
      lead: "The Spoonbill is our purpose-built two-person bag. Or pair two singles — one Right-Zip, one Left-Zip — and they zip together cleanly.",
      whyText: 'For couples and shared shelters, the Spoonbill is an ultralight delight. Our other bags can be zipped together, but for efficency, the Spoonbill is it.',
      ids
    };
  }

  // Women's path
  if (who === 'women') {
    // Snug fit takes priority over temperature — Hummingbird is the narrowest cut in the line,
    // even if it's not women's-specific. Egret follows as the women's-cut alternative.
    if (fit === 'snug') {
      if (temp === '10to20') return {
        type: 'recs',
        heading: 'The Hummingbird UL 20 — <em>narrowest cut, cold-edge warmth.</em>',
        lead: 'When you want the snuggest fit and 10–20°F warmth.',
        whyText: "The Hummingbird is the narrowest cut in our line: not women's-specific, but the snug fit you've signaled wins out at this weight. The Petrel UL 10 is the warmer women's-cut alternative; the Egret UL 20 sits between them.",
        ids: ['hummingbird-ul', 'petrel-ul-10', 'egret-ul']
      };
      if (temp === '20to30') return {
        type: 'recs',
        heading: 'The Hummingbird UL 20 — <em>narrowest cut, three-season range.</em>',
        lead: 'Snug, light, 20°F-rated.',
        whyText: "The narrowest mummy in our line. If you've prioritized a snug fit over a women's-specific cut, this is the answer. The Egret UL 20 is the women's-cut alternative; the Flicker is the most versatile across temperatures.",
        ids: ['hummingbird-ul', 'egret-ul', 'flicker-ul']
      };
      // above30 + snug
      return {
        type: 'recs',
        heading: 'The Hummingbird UL 30 — <em>summer-light, snug-cut.</em>',
        lead: 'Our narrowest mummy at summer weight.',
        whyText: 'Snug, light, and built for warm summer nights. The Egret UL 30 is the women\'s-cut alternative; the Flicker is the most adaptable across the season.',
        ids: ['hummingbird-ul', 'egret-ul', 'flicker-ul']
      };
    }

    // Non-snug women's branches
    if (temp === '10to20') return {
      type: 'recs',
      heading: 'The Petrel UL 10 — <em>our warmest women\'s bag.</em>',
      lead: 'Built for cold sleepers and shoulder-season women\'s adventures.',
      whyText: 'Designed with extra fill in the chest and footbox where women lose heat fastest. The Egret UL 20 is the lighter alternative; the Flicker is the most versatile across temperatures.',
      ids: ['petrel-ul-10', 'egret-ul', 'flicker-ul']
    };
    if (temp === '20to30') {
      if (fit === 'quilt') return {
        type: 'recs',
        heading: 'The Flicker — <em>our most versatile quilt.</em>',
        lead: 'Adapts to warm and cold nights, no zipper bottom.',
        whyText: "A hoodless quilt that adapts across 20°F, 30°F, and 40°F nights. The Flicker Wide adds room for side sleepers; the Egret UL 20 is the women's mummy alternative.",
        ids: ['flicker-ul', 'flicker-wide-ul', 'egret-ul']
      };
      // standard / roomier
      return {
        type: 'recs',
        heading: 'The Egret UL 20 — <em>the women\'s flagship.</em>',
        lead: 'Our most popular women\'s bag. Warmer through the core, narrower shoulder.',
        whyText: 'Most popular three-season women\'s bag. The Flicker is a strong alternative if you want one bag that adapts across summer through fall. The Petrel is the warmer pick if you sleep cold.',
        ids: ['egret-ul', 'flicker-ul', 'petrel-ul-10']
      };
    }
    // above 30 women's
    return {
      type: 'recs',
      heading: 'The Flicker UL — <em>summer\'s most adaptable bag.</em>',
      lead: 'A quilt that runs from 40°F warm-summer nights into shoulder season.',
      whyText: 'For a range of summer trips, the Flicker is a fantastic option. Its 40°F vent-and-adapt range covers warm nights without sacrificing warmth when temps drop. The Egret UL 30 is the women\'s mummy pick if you prefer a hood and full enclosure.',
      ids: ['flicker-ul', 'egret-ul', 'flicker-wide-ul']
    };
  }

  // Men's / Unisex path

  // Snug fit takes priority over temperature — Hummingbird is the answer
  // wherever someone has signaled they want narrow / lightweight
  if (fit === 'snug') {
    if (temp === '10to20') return {
      type: 'recs',
      heading: 'The Hummingbird UL 20 — <em>snug, light, and warm enough for the cold edge.</em>',
      lead: 'Our narrowest mummy, rated to 20°F.',
      whyText: "When you've signaled you want a snug fit, the Hummingbird is the answer: narrower cut, lighter shell, same 950+ down. The Swallow UL 20 is the slightly roomier alternative if you want more space; the Flicker is the most versatile across temperatures.",
      ids: ['hummingbird-ul', 'swallow-ul', 'flicker-ul']
    };
    if (temp === '20to30') return {
      type: 'recs',
      heading: 'The Hummingbird — <em>for the gram-counter.</em>',
      lead: 'Our narrowest, lightest mummy.',
      whyText: "Our narrowest, lightest mummy. If you measure gear in grams and don't mind a snug bag, this is the answer. The Flicker is the most versatile alternative; the Tanager is the stripped-down minimalist pick.",
      ids: ['hummingbird-ul', 'flicker-ul', 'tanager-cfl']
    };
    // above30 + snug
    return {
      type: 'recs',
      heading: 'The Hummingbird UL 30 — <em>summer-light, snug-cut.</em>',
      lead: 'Our narrowest mummy at summer weight.',
      whyText: 'Snug, light, and built for warm summer nights. The Vireo is the minimalist pairing-with-a-puffy alternative; the Flicker is the most versatile if you want one bag that adapts across the season.',
      ids: ['hummingbird-ul', 'vireo-ul', 'flicker-ul']
    };
  }

  // Non-snug temperature branches
  if (temp === '10to20') return {
    type: 'recs',
      heading: 'The Flicker UL Quilt — <em>thru-hiker beloved.</em>',
      lead: 'Hooded quilt with the versatility quilt fans love.',
      whyText: "Adaptable across 20°F, 30°F, and 40°F nights. One bag for the whole season. If the PCT, AT, or CDT are on your mind, this is a good choice. If you're a side sleeper or just want more room, the Wide version is worth the few extra ounces.",
    ids: ['flicker-ul', 'flicker-wide-ul', 'swallow-ul']
  };

  if (temp === '20to30') {
    if (fit === 'quilt') return {
      type: 'recs',
      heading: 'The Flicker UL Quilt — <em>thru-hiker beloved.</em>',
      lead: 'Hooded quilt with the versatility quilt fans love.',
      whyText: "Adaptable across 20°F, 30°F, and 40°F nights. One bag for the whole season. If the PCT, AT, or CDT are on your mind, this is a good choice. If you're a side sleeper or just want more room, the Wide version is worth the few extra ounces.",
      ids: ['flicker-ul', 'flicker-wide-ul', 'swallow-ul']
    };
    if (fit === 'roomier') return {
      type: 'recs',
      heading: 'The Flicker Wide — <em>semi-rectangular comfort.</em>',
      lead: 'Quilt sprawl-friendly for side sleepers.',
      whyText: 'For sprawl-sleepers who hate mummies. The most space-friendly option in our UL line. The standard Flicker is the lighter alternative if width matters less than weight.',
      ids: ['flicker-wide-ul', 'flicker-ul', 'swallow-ul']
    };
    // standard
    return {
      type: 'recs',
      heading: 'The Flicker UL Quilt — <em>backpacker beloved.</em>',
      lead: 'Hooded quilt with the versatility quilt fans love.',
      whyText: "Adaptable across 20°F, 30°F, and 40°F nights. One bag for the whole season. If the PCT, AT, CDT, or any backpacking adventure is on your mind, this is a good choice. If you're a side sleeper or just want more room, the Wide version is worth the few extra ounces.",
    ids: ['flicker-ul', 'flicker-wide-ul', 'swallow-ul']
    };
  }

  // above30 men's, non-snug — Flicker primary for summer versatility
  return {
    type: 'recs',
    heading: 'The Flicker UL — <em>summer\'s most adaptable bag.</em>',
    lead: 'A quilt that runs from 40°F warm-summer nights into shoulder season.',
    whyText: 'For a range of summer trips, the Flicker is a fantastic option. Its vent-and-adapt range covers warm nights without sacrificing warmth when temps drop. The Swallow UL 30 is the mummy purist\'s pick; the Hummingbird saves a few ounces.',
    ids: ['flicker-ul', 'swallow-ul', 'hummingbird-ul']
  };
}

/* ============================================================
   RESULT RENDERING
   ============================================================ */
function renderResult() {
  const r = recommend();

  // Fire QuizComplete
  trackEvent('QuizComplete', {
    quiz_name: 'find_your_bag',
    result_type: r.type,
    primary_product: r.ids ? r.ids[0] : null,
    answers: state.answers
  });

  if (r.type === 'winter_redirect') {
    result.innerHTML = `
      <div class="winter-redirect">
        <div class="redirect-eyebrow">Beyond Three-Season</div>
        <h3>Below 10°F is winter territory. <em>You might want to check out our new Winter Light line.</em></h3>
        <p>Three-season bags top out around 10°F. For 0°F and -10°F, we make a dedicated line of <strong>Winter Light</strong> sleeping bags with the same ultralight philosophy, 900+ fill, with a heat-reflecting FlyTi lining and a Pertex® Quantum Pro® shell to push the rating colder without adding bulk.</p>

        <div class="winter-light-grid">
          <div class="winter-light-card">
            <div class="wl-temp">0°F</div>
            <div class="wl-bags">
              <div class="wl-bag"><strong>Snowbunting Light</strong> · Standard Mummy · From $829</div>
              <div class="wl-bag"><strong>Murre Light</strong> · Women's Mummy · From $789</div>
              <div class="wl-bag"><strong>Ibis Light</strong> · Wide Mummy · From $859</div>
            </div>
          </div>
          <div class="winter-light-card">
            <div class="wl-temp">-10°F</div>
            <div class="wl-bags">
              <div class="wl-bag"><strong>Widgeon Light</strong> · Standard Mummy · From $929</div>
              <div class="wl-bag"><strong>Arctic Finch Light</strong> · Women's Mummy · From $879</div>
              <div class="wl-bag"><strong>Eider Light</strong> · Wide Mummy · From $959</div>
            </div>
          </div>
        </div>

        <p class="wl-note">Best for drier alpine and shoulder-winter conditions where weight matters more than waterproofing. For wetter or sub--10°F conditions, see our full <a href="/collections/winter-expedition-sleeping-bags" style="color: #fff; text-decoration: underline;">Winter & Expedition</a> line.</p>

        <a href="/collections/new-winter-light-down-sleeping-bags" class="cta">Explore Winter Light Sleeping Bags →</a>
      </div>
      <div class="result-actions" style="margin-top: 28px;">
        <button data-restart>Start Over</button>
      </div>
    `;
    bindResultActions();
    return;
  }

  const cards = r.ids.map((id, i) => renderCard(id, i === 0, i === 0 ? r.whyText : null)).join('');
  const cardsClass = r.ids.length === 3 ? 'three' : r.ids.length === 2 ? 'two' : '';

  result.innerHTML = `
    <span class="result-eyebrow">Your Match</span>
    <h3 class="result-heading">${r.heading}</h3>
    <p class="result-lead">${r.lead}</p>
    <div class="result-cards ${cardsClass}">${cards}</div>
    <div class="result-actions">
      <button data-restart>Start Over</button>
      <a href="#bags-grid">See All Bags</a>
    </div>
    <div class="help-prompt">
      <div class="help-text">
        <strong>Still on the fence?</strong> Feel free to contact us! Our Seattle staff helps people through this exact decision every day. We're happy to help. It's a 5-minute conversation that saves you a returned bag.
      </div>
      <a href="/pages/contact-us" class="btn">Contact Us</a>
    </div>
  `;
  bindResultActions();
}

function renderCard(id, isPrimary, whyText) {
  const p = PRODUCTS[id];
  if (!p) return '';
  const why = (isPrimary && whyText) ? `
    <div class="why-this-one">
      <div class="why-label">Why this one</div>
      <div class="why-text">${whyText}</div>
    </div>` : '';

  return `
    <div class="bag-card ${isPrimary ? 'primary' : ''}">
      <div class="bag-image-wrapper">
        <span class="bag-label">${isPrimary ? 'Best Match' : p.label}</span>
        <img src="${p.image}" alt="${p.name} ${p.nameSecondary}" loading="lazy">
      </div>
      <div class="bag-content">
        <h3 class="bag-title">
          <span class="title-primary">${p.name}</span>
          <span class="title-secondary">${p.nameSecondary}</span>
        </h3>
        <p class="bag-subtext">${p.tagline}</p>
        ${why}
        <ul class="bag-specs">
          <li><strong>Temp Rating:</strong> ${p.temp}</li>
          <li><strong>Weight:</strong> ${p.weight}</li>
          <li><strong>Fill:</strong> ${p.fill}</li>
          <li><strong>Fabric:</strong> ${p.fabric}</li>
        </ul>
        <div class="bag-review">
          <blockquote>"${p.quote}"</blockquote>
          <cite>— ${p.quoteSrc}</cite>
        </div>
        <div class="bag-footer">
          <span class="bag-price">${p.price}</span>
          <a href="${p.url}" class="btn" data-product="${id}">Shop Now</a>
        </div>
      </div>
    </div>
  `;
}

function bindResultActions() {
  const restart = result.querySelector('[data-restart]');
  if (restart) restart.addEventListener('click', () => {
    state.answers = {};
    state.started = false;
    showStep(0);
    document.getElementById('quiz').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  result.querySelectorAll('.bag-shop-btn[data-product]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.product;
      const p = PRODUCTS[id];
      if (p) {
        trackEvent('QuizProductClick', { quiz_name: 'find_your_bag', product: id });
        if (typeof fbq === 'function') {
          fbq('track', 'ViewContent', {
            content_name: p.name + ' ' + p.nameSecondary,
            content_type: 'product',
            currency: 'USD'
          });
        }
      }
    });
  });
}

/* ============================================================
   ANALYTICS HELPER — fires to fbq + gtag if available
   ============================================================ */
function trackEvent(name, params) {
  try {
    if (typeof fbq === 'function') fbq('trackCustom', name, params || {});
    if (typeof gtag === 'function') gtag('event', name.toLowerCase(), params || {});
  } catch (e) { /* noop */ }
}